export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14348.f102a0f8.jpg";